import { EqlField } from 'generated/graphql';
import { useCallback } from 'react';
import { useIsUnifiedFieldsEnabled } from './useIsUnifiedFieldsEnabled';

export const useShouldShowEQLFieldTooltipInQB = () => {
  const isUnifiedFieldEnabled = useIsUnifiedFieldsEnabled();

  return useCallback(
    (field: EqlField) => {
      const isCommonField = field.detail?.metadata?.source === 'Common';

      return isUnifiedFieldEnabled && isCommonField;
    },
    [isUnifiedFieldEnabled],
  );
};
